import type { Locale, MenuMap } from "./types";

export const CONTENT_MAX = 1200;

export const NAV_LOCALES: ReadonlyArray<Locale> = [
  { code: "en-AU", flagSrc: "https://flagcdn.com/w80/au.png", label: "Australia" },
  { code: "en-CA", flagSrc: "https://flagcdn.com/w80/ca.png", label: "Canada (English)" },
  { code: "fr-CA", flagSrc: "https://flagcdn.com/w80/ca.png", label: "Canada (French)" },
  { code: "en-US", flagSrc: "https://flagcdn.com/w80/us.png", label: "United States" },
  { code: "en-GB", flagSrc: "https://flagcdn.com/w80/gb.png", label: "United Kingdom" },
  { code: "en-SG", flagSrc: "https://flagcdn.com/w80/sg.png", label: "Singapore" },
  { code: "en-ZA", flagSrc: "https://flagcdn.com/w80/za.png", label: "South Africa" },
  { code: "en-IE", flagSrc: "https://flagcdn.com/w80/ie.png", label: "Ireland" },
  { code: "global-en", flagSrc: null, label: "Global (English)" },
  { code: "global-es", flagSrc: null, label: "Global (Spanish)" },
];

export const FOOTER_LOCALES: ReadonlyArray<Locale> = [
  { code: "en-AU", flagSrc: "https://flagcdn.com/w80/au.png", label: "Australia" },
  { code: "pt-BR", flagSrc: "https://flagcdn.com/w80/br.png", label: "Brasil" },
  { code: "en-CA", flagSrc: "https://flagcdn.com/w80/ca.png", label: "Canada (English)" },
  { code: "fr-CA", flagSrc: "https://flagcdn.com/w80/ca.png", label: "Canada (French)" },
  { code: "fr-FR", flagSrc: "https://flagcdn.com/w80/fr.png", label: "France" },
  { code: "en-IN", flagSrc: "https://flagcdn.com/w80/in.png", label: "India" },
  { code: "en-GB", flagSrc: "https://flagcdn.com/w80/gb.png", label: "United Kingdom" },
  { code: "en-ZA", flagSrc: "https://flagcdn.com/w80/za.png", label: "South Africa" },
  { code: "en-SG", flagSrc: "https://flagcdn.com/w80/sg.png", label: "Singapore" },
  { code: "other", flagSrc: null, label: "Other Countries" },
];

export const MENUS: MenuMap = {
  "Get Started": [
    { label: "Get Started hub", href: "#" },
    { label: "Onboarding programs", href: "#" },
  ],
  Topics: [
    { label: "Account management", href: "#" },
    { label: "Accounting", href: "#" },
    { label: "Banking", href: "#" },
    { label: "Expenses and suppliers", href: "#" },
    { label: "Get started", href: "#" },
    { label: "Invoices and payments", href: "#" },
    { label: "Payroll", href: "#" },
    { label: "Reports", href: "#" },
    { label: "Sales and customers", href: "#" },
    { label: "Taxes", href: "#" },
    { label: "View all help", href: "#" },
    { label: "Year End Resources", href: "#" },
  ],
  Training: [
    { label: "Tutorials (Videos)", href: "#" },
    { label: "Webinars", href: "#" },
    { label: "Novala Courses", href: "#" },
  ],
  Community: [
    { label: "Community Home", href: "#" },
    { label: "Novala Q&A", href: "#" },
    { label: "Community Basics", href: "#" },
    { label: "Champions Program", href: "#" },
    { label: "Ask the Community", href: "#" },
  ],
  Resources: [
    { label: "Find an Expert", href: "#" },
    { label: "Novala Blog", href: "#" },
    { label: "Product Updates", href: "#" },
    { label: "Novala Status page", href: "#" },
    { label: "Novala Toolkits", href: "#" },
  ],
};

export const RELATED_LINKS: ReadonlyArray<string> = [
  "Get started with Novala Payroll",
  "Set up time tracking",
  "Set up pay schedules",
  "Set up voluntary deductions",
];